import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Admin/Sidebar';
import * as Icon from 'react-bootstrap-icons';
import Table from 'react-bootstrap/Table';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Pagination from 'react-bootstrap/Pagination';

const AdminAllSellerOrder = () => {
  const [toggleValue, setToggleValue] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [orders, setOrders] = useState([]);
  const [sellerId, setsellerId] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // Define per page items (7 in your case)
  const [totalPages, setTotalPages] = useState(1); // Total pages calculation
  const { id } = useParams();

  useEffect(() => {
    getOrder();
  }, []);

  const getOrder = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}order/getSellerDetailsByAdmin/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const allSellerOrderHistory = response.data.data;
      setOrders(allSellerOrderHistory.orders);
      setsellerId(response.data.data.sellerUid);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    setTotalPages(Math.ceil(orders.length / itemsPerPage));
    if (currentPage > Math.ceil(orders.length / itemsPerPage)) {
      setCurrentPage(1); // Reset page if currentPage is out of range
    }
  }, [orders, itemsPerPage, currentPage]);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const ordersShow = Array.isArray(orders)
    ? orders.slice(indexOfFirstItem, indexOfLastItem)
    : [];

  const renderPaginationItems = () => {
    const items = [];

    items.push(
      <Pagination.Item
        key={1}
        active={currentPage === 1}
        onClick={() => handlePageClick(1)}
      >
        1
      </Pagination.Item>
    );

    if (currentPage > 3) {
      items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    for (let page = currentPage - 1; page <= currentPage + 1; page++) {
      if (page > 1 && page < totalPages) {
        items.push(
          <Pagination.Item
            key={page}
            active={currentPage === page}
            onClick={() => handlePageClick(page)}
          >
            {page}
          </Pagination.Item>
        );
      }
    }

    if (currentPage < totalPages - 2) {
      items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    if (totalPages > 1) {
      items.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages}
          onClick={() => handlePageClick(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  useEffect(() => {
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-2 p-0 bg-dark">
          <Sidebar toggleSidebar={toggleValue} setToggleValue={setToggleValue} />
        </div>
        <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
          <Icon.ArrowRight
            onClick={() => setToggleValue(true)}
            className="my-5 sidebar-open"
            color="black"
            size={30}
          />
          <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
            <div className="col-12">
              <h5>All Orders</h5>
              <h6 className="text-muted">View orders</h6>
            </div>

            {/* Orders Table Section */}
            <div className="col-12 mt-5">
              <Table striped bordered hover responsive="sm">
                <thead className='text-center'>
                  <tr>
                    <th>Order ID</th>
                    <th>Total Amount</th>
                    <th>Date</th>
                    <th>Products</th>
                    <th className="text-center">View</th>
                  </tr>
                </thead>
                <tbody>
                  {ordersShow.map((order, index) => {
                    const date = new Date(order.createdAt);
                    const formattedDate = date.toLocaleDateString('en-IN');
                    const formattedTime = date.toLocaleTimeString('en-IN', { hour12: false });

                    return (
                      <tr key={index}>
                        <td>{order.orderNumber}</td>
                        <td><Icon.CurrencyRupee />{order.totalAmount}</td>
                        <td>{formattedDate + ' ' + formattedTime}</td>
                        <td>
                          <div className='row'>
                            {order.products && order.products.length > 0 ? (
                              order.products.map((item, j) => (
                                <div
                                  key={j}
                                  className={`${order.products.length > 2
                                    ? "col-4"
                                    : order.products.length === 2
                                      ? "col-6"
                                      : "col-12"
                                    } mb-1`}
                                >
                                  <div className="card p-1">
                                    <span className='text-dark' style={{ fontSize: "12px" }}>{item.title}</span>
                                    <span className='text-tantinary fw-bold' style={{ fontSize: "10px" }}>Price - ₹{item.update_price}</span>
                                    <span className='text-tantinary fw-bold' style={{ fontSize: "10px" }}>Quantity - {item.quantity}</span>
                                    <span className='text-secondary fw-bold mt-1' style={{ fontSize: "10px" }}>Status - {item.orderStatus}</span>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className='col-12'>No Products Available</div>
                            )}
                          </div>
                        </td>
                        <td className="text-center">
                          <Link
                            to={`/allsellerorderlist/${sellerId}/${order.orderNumber}`}
                            className="btn btn-outline-dark"
                          >
                            <Icon.ArrowRight />
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>


            {/* Pagination controls */}
            {
              ordersShow.length > 0 &&
              <div className='col-12 d-flex justify-content-center mt-2'>
                <Pagination>
                  <Pagination.First
                    onClick={() => handlePageClick(1)}
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev
                    onClick={() => handlePageClick(currentPage - 1)}
                    disabled={currentPage === 1}
                  />

                  {renderPaginationItems()}

                  <Pagination.Next
                    onClick={() => handlePageClick(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last
                    onClick={() => handlePageClick(totalPages)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            }

            {/* Pagination end */}

          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAllSellerOrder;















